import React, { memo } from 'react';

import SourceLayers from '../../source-layers/SourceLayers';

export const WATERBODIES_SOURCE_ID = 'waterbodies-transparent';
export const WATERBODIES_LAYER_ID = 'waterbodies-transparent';

const WaterbodiesTransparentLayerInternal = () => (
  <SourceLayers
    source={{
      id: WATERBODIES_SOURCE_ID,
      data: {
        type: 'vector',
        url: 'mapbox://mapbox.mapbox-streets-v8',
      },
    }}
    layers={{
      id: WATERBODIES_LAYER_ID,
      type: 'fill',
      source: WATERBODIES_SOURCE_ID,
      'source-layer': 'water',
      paint: {
        'fill-color': [
          'coalesce',
          ['feature-state', 'fillColor'],
          'transparent',
        ],
        'fill-color-transition': {
          duration: 0,
          delay: 0,
        },
        'fill-antialias': true,
        'fill-translate': [0, 0],
      },
    }}
  />
);

WaterbodiesTransparentLayerInternal.displayName = 'WaterbodiesTransparentLayer';

export const WaterbodiesTransparentLayer = memo(
  WaterbodiesTransparentLayerInternal,
);
